'use client';

import {useLocale} from 'next-intl';
import PartnersSection from '@/components/home/PartnersSection';

const LABELS: Record<string, {home: string; crumb: string; title: string; intro: string}> = {
  fr: {
    home: 'Accueil',
    crumb: 'Partenaires',
    title: 'Nos Partenaires',
    intro: "L'UTSS agit en réseau avec les institutions publiques, les organisations internationales et les acteurs de la société civile pour amplifier l'impact de ses programmes sociaux à travers la Tunisie.",
  },
  ar: {
    home: 'الرئيسية',
    crumb: 'الشركاء',
    title: 'شركاؤنا',
    intro: 'يعمل الاتحاد التونسي للتضامن الاجتماعي ضمن شبكة من المؤسسات العمومية والمنظمات الدولية وفاعلي المجتمع المدني لتعزيز أثر برامجه الاجتماعية في كامل تراب الجمهورية.',
  },
  en: {
    home: 'Home',
    crumb: 'Partners',
    title: 'Our Partners',
    intro: 'UTSS works in partnership with public institutions, international organizations and civil society actors to amplify the impact of its social programs across Tunisia.',
  },
};

export default function PartenairesPage() {
  const locale = useLocale();
  const l = LABELS[locale] || LABELS.fr;

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <nav className="text-sm text-muted mb-6">
          <a href={`/${locale}`} className="hover:text-primary">{l.home}</a>
          <span className="mx-2">/</span>
          <span className="text-foreground">{l.crumb}</span>
        </nav>
        <h1 className="text-3xl font-bold text-primary mb-3">{l.title}</h1>
        <p className="text-muted max-w-3xl mb-2">{l.intro}</p>
      </div>
      <PartnersSection showTitle={false} />
    </div>
  );
}
